module.exports = __webpack_public_path__ + "img/SHProjectManage.cf0663ea.svg";